import React from 'react';
import { Link, LinkProps } from 'react-scroll';

export interface IAnchorLinkProps extends LinkProps {}

function AnchorLink({ children, duration = 300, ...otherProps }: IAnchorLinkProps, ref) {
  return (
    <Link ref={ref} duration={duration} {...otherProps}>
      {children}
    </Link>
  );
}

export default React.forwardRef(AnchorLink);
export const AnchorLinkNoRef = AnchorLink;
